import type { ApolloError } from '@apollo/client'
import { createContext } from 'react'

import type { CartFragment } from '../../graphql/magento'
import { MagentoScopeNotGrantedError } from '../auth/errors'
import { CartType } from './reducers/cart-get-state'

export interface CartContextValue {
  cart?: CartFragment
  loading: boolean
  error?: ApolloError | Error | MagentoScopeNotGrantedError
  setAllowGuestCart: (allowGuestCart: boolean) => void
  refetch?: () => void
  type: CartType
}

export type NonEmptyCartContextValue = CartFragment

export interface ToggleCartContextValue {
  isCartOpen: boolean
  toggleCart(triggerElement?: HTMLElement | null): void
  hideCart(): void
  showCart(triggerElement?: HTMLElement | null): void
}

export const CartContext = createContext<CartContextValue>({
  cart: undefined,
  error: undefined,
  loading: false,
  type: 'none',
  setAllowGuestCart: () => {
    // empty initializer
  },
  refetch: () => {
    // empty initializer
  },
})

export const NonEmptyCartContext = createContext<NonEmptyCartContextValue>({
  id: '-1',
  shipping_addresses: [],
  total_quantity: 0,
})

export const ToggleCartContext = createContext<ToggleCartContextValue>({
  isCartOpen: false,
  toggleCart(_triggerElement?: HTMLElement | null) {
    console.warn('Toggle cart context not initialized')
  },
  hideCart() {
    console.warn('Hide cart context not initialized')
  },
  showCart(_triggerElement?: HTMLElement | null) {
    console.warn('Show cart context not initialized')
  },
})
